export const BILLPLZ = "billplz";
export const HITPAY = "hitpay";
export const HITPAY_MY = "hitpay_my";
export const OFFLINE = "offline";
export const CREDIT = "credit";
